module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    attrs: {
      "color": _vm.snackbarColor
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarMsg) + "\n    "), _c('v-btn', {
    attrs: {
      "color": "orange",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("fermer")])], 1), _vm._v(" "), _c('v-bottom-sheet', {
    model: {
      value: (_vm.sheet),
      callback: function($$v) {
        _vm.sheet = $$v
      },
      expression: "sheet"
    }
  }, [_c('div', {
    attrs: {
      "id": "moderationMap"
    }
  })]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h1', {
    staticClass: "pt-5"
  }, [_vm._v("Activité non validée")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.areaNeedingValidation.headers,
      "items": _vm.areaNeedingValidation.list
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          on: {
            "click": function($event) {
              return _vm.showMap(props.item.area)
            }
          }
        }, [_vm._v(_vm._s(props.item.area))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.activity))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.timestamp))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.date))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.user))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.comment))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.equipementRating))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.surroundingsRating))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.equipmentList))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          attrs: {
            "color": "success",
            "fab": ""
          },
          on: {
            "click": function($event) {
              return _vm.validate(props.item.validationPath)
            }
          }
        }, [_vm._v("V")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "error",
            "fab": ""
          },
          on: {
            "click": function($event) {
              return _vm.reject(props.item.validationPath)
            }
          }
        }, [_vm._v("X")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapAdmin"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14a8d035","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Moderation.vue
// module id = 452
// module chunks = 1